import { logger } from 'src/analytics/KatalLogger';
import { MasterCorpSegments, SegmentHierarchy } from 'src/models/AppContextModels';
import { getFileFromS3URI } from 'src/utils/aws-s3-services';

/**
 * Fetches segment hierarchy data from S3 for a given master segment.
 * Returns the segment with empty hierarchy data on failure.
 */
export const fetchCorpSegmentDataFromS3 = async (segment: MasterCorpSegments): Promise<MasterCorpSegments> => {
  try {
    const dataFromS3 = await getFileFromS3URI(segment.segment_hierarchy_s3_path);
    return {
      ...segment,
      segment_hierarchy_data_from_s3: dataFromS3 as unknown as SegmentHierarchy[]
    };
  } catch (s3Error: unknown) {
    logger.error('Failed to fetch S3 data for segment:', { error: String(s3Error), segmentName: segment.segment_name });
    return {
      ...segment,
      segment_hierarchy_data_from_s3: []
    };
  }
};
